import React from 'react';
import {
    Select,
    TextField,
    Stack
} from '@shopify/polaris';
import { SelectFilterTypes } from '../common/Helpers';

const conditions = [
    { label: 'is at least', value: 'AtLeast' },
    { label: 'is at most', value: 'AtMost' },
    { label: 'is exactly', value: 'Exactly' }
];

const unitsOfTime = [
    { label: 'minutes', value: 'Minutes' },
    { label: 'hours', value: 'Hours' },
    { label: 'days', value: 'Days' },
];

class TimeSinceProductCreatedFilterComponent extends React.Component {
    state = {};

    render() {

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected) => this.onFilterTypeChange(selected)}
                />
                <Select
                    options={conditions}
                    value={this.props.filter.condition}
                    onChange={(selected) => this.onConditionChange(selected)}
                />
                <TextField
                    placeholder="Length of time"
                    type="number"
                    inputMode="numeric"
                    value={this.props.filter.timeOffsetLength.toString()}
                    onChange={(newValue) => this.onLengthChange(newValue)}
                />
                <Select
                    options={unitsOfTime}
                    value={this.props.filter.timeOffsetUnit}
                    onChange={(selected) => this.onUnitChange(selected)}
                />
            </Stack>
        );
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.condition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onUnitChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.timeOffsetUnit = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onLengthChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.timeOffsetLength = parseInt(newValue);

        this.props.onFilterUpdated(newFilter);
    }
}

export default TimeSinceProductCreatedFilterComponent;
